import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'offconon-rbac-no-access-rights',
  templateUrl: './rbac-no-access-rights.component.html',
  imports: [ButtonModule, TranslateModule],
})
export class RbacNoAccessRightsComponent {
  private router = inject(Router);

  @Input() redirect_url = '/co-workers/system-administrators';

  buttonClicked() {
    this.router.navigate([this.redirect_url]);
  }
}
